import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MasterRoutingModule } from './master-routing.module';
import { MainRoutingModule } from '@app/main/main-routing.module';
import { AppCommonModule } from '@app/shared/common/app-common.module';
import { SubheaderModule } from '@app/shared/common/sub-header/subheader.module';
import { FormsModule } from '@angular/forms';
import { Angular2CountoModule } from '@awaismirza/angular2-counto';
import { BsDatepickerConfig, BsDatepickerModule, BsDaterangepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'primeng/tooltip';
import { UtilsModule } from '@shared/utils/utils.module';
import { NgxBootstrapDatePickerConfigService } from 'assets/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';
import { CompaniesComponent } from './companies/companies.component';
import { CreateOrEditCompanyComponent } from './companies/create-or-edit-company.component';
import { AdminSharedModule } from '@app/admin/shared/admin-shared.module';
import { AppSharedModule } from '@app/shared/app-shared.module';
import { CreateOrEditLocationComponent } from './locations/create-or-edit-location.component';
import { LocationsComponent } from './locations/locations.component';
import { CreateOrEditPaymentTermModalComponent } from './paymentTerms/create-or-edit-paymentTerm-modal.component';
import { PaymentTermsComponent } from './paymentTerms/paymentTerms.component';
import { CreateOrEditCurrencyModalComponent } from './currencies/create-or-edit-currency-modal.component';
import { CurrenciesComponent } from './currencies/currencies.component';
import { CreateOrEditPaymentTypeModalComponent } from './paymentTypes/create-or-edit-paymentType-modal.component';
import { PaymentTypesComponent } from './paymentTypes/paymentTypes.component';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { TaxesComponent } from './taxes/taxes.component';
import { CreateOrEditTaxComponent } from './taxes/create-or-edit-tax.component';
import { ChangeCrystalReportComponent } from './change-crystal-report/change-crystal-report.component';

// NgxBootstrapDatePickerConfigService.registerNgxBootstrapDatePickerLocales();

@NgModule({
  declarations: [CompaniesComponent,
      CreateOrEditCompanyComponent,
      LocationsComponent, 
      CreateOrEditLocationComponent,
      PaymentTermsComponent,
      CreateOrEditPaymentTermModalComponent,
      PaymentTypesComponent,
      CreateOrEditPaymentTypeModalComponent,
      CurrenciesComponent,
      CreateOrEditCurrencyModalComponent,
      TaxesComponent,
      CreateOrEditTaxComponent,
      ChangeCrystalReportComponent,

],
  imports: [
        CommonModule,
        FormsModule,
        ModalModule,
        TabsModule,
        TooltipModule,
        AppCommonModule,
        UtilsModule,
        MasterRoutingModule,
        AppSharedModule, 
        Angular2CountoModule,
        FileUploadModule,
        BsDatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        PopoverModule.forRoot(),
        SubheaderModule,
  ],
  providers: [
          { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
          { provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig },
          { provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale },
      ],
})
export class MasterModule { }
